import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-placement-report',
  templateUrl: './placement-report.component.html',
  styleUrls: ['./placement-report.component.css']
})
export class PlacementReportComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<PlacementReportComponent>
  ) { }

  ngOnInit() {
    console.log(this.data);
  }

  print() {
    console.log(this.data);
    let placementReport = document.getElementById('placementReport').innerHTML;
    let newWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    newWindow.document.open();
    newWindow.document.write(`
    <html>
        <head>
          <title>Print tab</title>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.3.0/paper.css">
          <style>
          @page { size: A5 landscape }
          </style>
        </head>
        <body class="A5 landscape" onload="window.print();window.close()">
        <section class="sheet padding-10mm">
        <article>${placementReport}</article>
        </section>
        </body>
      </html>
    `);
    newWindow.document.close();
  }

  onClose() {
    this.dialog.close();
  }

}
